import styled from "styled-components";

export const LiveSentimentContainer = styled.div``;